<div class="contact-import-notification d-flex align-items-start gap-2">
  <i class="fas fa-file-import contact-import-notification__icon notification-item-icon" aria-hidden="true"></i>
  <div class="d-flex flex-column align-items-start gap-1">
    <span class="small">
      @if (payload.isFailed) {
        {{ 'AgenticCX::Notification:ContactImport:FailedMessage' | abpLocalization: payload.fileName }}
      } @else {
        {{ 'AgenticCX::Notification:ContactImport:Message' | abpLocalization: messageParams }}
      }
    </span>

    @if (canViewResult) {
      <button
        type="button"
        class="btn btn-link btn-sm p-0 text-decoration-underline"
        (click)="openResult($event)">
        {{ 'AgenticCX::Notification:ContactImport:View' | abpLocalization }}
      </button>
    }
  </div>
</div>

@if (canViewResult) {
  <app-contact-import-result-dialog
    [importId]="payload.importId"
    [visible]="resultDialogVisible"
    (visibleChange)="resultDialogVisible = $event" />
}
